import { LinearGradient } from 'expo-linear-gradient'
import React from 'react'
import {
  Image,
  Platform,
  Pressable,
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle
} from 'react-native'
import Modal, { ModalProps } from 'react-native-modal'

import { useStore } from '../../models'

export interface CustomModalProps extends Partial<ModalProps> {
  children: React.ReactNode
  title?: string
  visible: boolean
  dismissDisabled?: boolean
  onClose: () => void
  gradientColor?: string[]
  showCloseButton?: boolean
  containerStyle?: StyleProp<ViewStyle>
  errorMsg?: string
  shadowColor?: string
  showShadow?: boolean
  isGameOver?: boolean
}

export const CommonModal = (props: CustomModalProps) => {
  const {
    dismissDisabled,
    shadowColor,
    showShadow,
    children,
    title,
    visible,
    onClose,
    gradientColor,
    showCloseButton,
    errorMsg,
    containerStyle,
    isGameOver,
    ...rest
  } = props
  const store = useStore()

  const [isLottieAnimOnFront, setIsLottieAnimOnFront] = React.useState(true)

  const shouldCloseLeaderBoard = () => {
    if (Platform.OS === 'web') return true

    if (store.game.modalQueue.length <= 0) return true
    return store.game.modalQueue[0].kind !== 'leaderBoard'
  }

  React.useEffect(() => {
    if (isGameOver && isLottieAnimOnFront) {
      setTimeout(() => {
        setIsLottieAnimOnFront(false)
      }, 8200)
    }
    return () => {
      setIsLottieAnimOnFront(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal {...rest} isVisible={visible} coverScreen={true} shouldRasterizeIOS style={{ margin: 0 }}>
      <View style={styles.errorMessageContainer}>
        {errorMsg ? (
          <Text allowFontScaling={false} style={styles.errorText}>
            {errorMsg}
          </Text>
        ) : null}
      </View>
      <Pressable
        onPress={
          (dismissDisabled !== undefined && dismissDisabled === true) || !shouldCloseLeaderBoard()
            ? () => null
            : onClose
        }
        style={[styles.modal, { zIndex: 9999 }]}
      >
        {title ? (
          <Text allowFontScaling={false} style={styles.modalTitle}>
            {title}
          </Text>
        ) : null}
        <Pressable
          onPress={(e) => {
            e.preventDefault()
          }}
          style={[
            showShadow
              ? {
                  elevation: 5,
                  shadowColor: shadowColor ? shadowColor : '#ffffff',
                  shadowOffset: { width: 0, height: 0 },
                  shadowOpacity: 0.5,
                  shadowRadius: 5
                }
              : {}
          ]}
        >
          <LinearGradient
            // @ts-ignore
            colors={gradientColor ? gradientColor : (['#49CDF2', '#49CDF2', '#9444FB'] as const)}
            start={{ x: 0.0, y: 1.0 }}
            end={{ x: 1.0, y: 1.0 }}
            style={[styles.modalContainer, containerStyle]}
          >
            {children}
          </LinearGradient>
          {showCloseButton !== false ? (
            <TouchableOpacity onPress={onClose} style={styles.modalCloseContainer}>
              <Image source={require('../../../assets/icons/close.png')} style={styles.closeImage} />
            </TouchableOpacity>
          ) : null}
        </Pressable>
      </Pressable>
    </Modal>
  )
}

const styles = StyleSheet.create({
  closeImage: {
    height: 30,
    width: 30
  },
  modalCloseContainer: {
    position: 'absolute',
    left: 20,
    top: -8
  },
  modalContainer: {
    marginHorizontal: 35,
    marginBottom: 20,
    backgroundColor: '#070D37',
    borderWidth: 0.5,
    borderRadius: 14,
    padding: 2
  },
  modal: {
    flex: 1,
    backgroundColor: '#00000070',
    justifyContent: 'center'
  },
  modalTitle: {
    color: '#fff',
    textAlign: 'center',
    fontSize: 22,
    fontFamily: 'HeroNew-BoldItalic',
    fontWeight: '700',
    paddingVertical: 10
  },
  errorMessageContainer: {
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    top: 50,
    height: 20
  },
  errorText: {
    color: '#E34234',
    textAlign: 'center'
  },
  lottieContainer: {
    left: 0,
    height: '100%',
    width: '100%'
  }
})
